export default __webpack_public_path__ + "static/media/pspIcon.b6616a3f.png";